module.exports = __webpack_public_path__ + "img/part-2-title.eb3b52d3.png";